import React from 'react';

export type FreeShippingSize = 'card' | 'gallery';

type Props = {
    classNames?: string;
    size?: FreeShippingSize;
};

// Ribbon geometry scales with the text size. Mobile first, then md (tablet) and lg (desktop).
const SIZES: Record<FreeShippingSize, { wrapper: string; band: string }> = {
    // 10px mobile, 12px tablet and desktop
    card: {
        wrapper:
            'w-[142px] h-[142px] md:w-[165px] md:h-[165px] lg:w-[189px] lg:h-[189px]',
        band: 'top-[25px] -left-[68px] w-[207px] py-1 text-[10px] md:top-[32px] md:-left-[90px] md:w-[242px] md:text-[12px] lg:w-[276px]',
    },
    // 14px mobile, 16px tablet, 18px desktop
    gallery: {
        wrapper:
            'w-[165px] h-[165px] md:w-[189px] md:h-[189px] lg:w-[212px] lg:h-[212px]',
        band: 'top-[41px] -left-[59px] w-[242px] py-1 text-[14px] md:top-[47px] md:-left-[67px] md:w-[276px] md:py-1.5 md:text-[16px] lg:top-[52px] lg:-left-[75px] lg:w-[310px] lg:text-[18px]',
    },
};

// Diagonal corner ribbon, matching the approved strip on corp.gourmetbasket.com.au.
// The wrapper clips the rotated band, so the parent needs no overflow-hidden.
const FreeShipping = ({ size = 'card' }: Props) => {
    const { wrapper, band } = SIZES[size];

    return (
        <div className={`absolute top-0 left-0 overflow-hidden pointer-events-none ${wrapper}`}>
            <span className={`absolute -rotate-45 bg-brand-primary-light text-center uppercase font-sans font-bold leading-tight tracking-wider text-white shadow-sm ${band}`}>
                Free Shipping
            </span>
        </div>
    );
};

export default FreeShipping;
